import * as React from "react"
import { BiChevronRightSquare } from "react-icons/bi"
import { CollapseButtonProps } from "./collapse-button.interface"
import { Root, IconContainer } from "./collapse-button.styled"
import { Box, Flex } from "@chakra-ui/react"
import { Icon } from "../../common/icons"
import { ExpandIcon } from "../../common/icons/expand-icon"
import useWindowSize from "../../../hooks/useWindowSize"

const _CollapseButton: React.FC<CollapseButtonProps> = ({
  setSidebarOpen,
  sidebarOpen,
  tabButtonStyle,
  isOneTab,
  servicePanelBackgroundColor,
  handleClickChatTab,
  canSeeChatTab,
  disabled,
}) => {
  const { color, textColor, ...otherStyles } = tabButtonStyle
  const { screenSize } = useWindowSize()
  const handleToggleSidebar = (): void => { 
    if (disabled) return
    setSidebarOpen(!sidebarOpen)
  }

  const handleOnClick = () => {
    if (disabled) return
    handleToggleSidebar()
    handleClickChatTab()
  }

  const isExpandIcon = React.useMemo(
    () => screenSize.width > 1605 || screenSize.height > 1025,
    [screenSize.height, screenSize.width]
  )

  return (
    <>
      {!isOneTab ? (
        <Root>
          <IconContainer isExpandIcon={isExpandIcon}>
            {isExpandIcon && <ExpandIcon />}
            <Icon
              as={BiChevronRightSquare}
              onClick={handleToggleSidebar}
              className={`sidebar-trigger ${sidebarOpen ? "open" : "close"}`}
              fontSize="32px"
              {...otherStyles}
              color={`${color}`}
              marginTop={isExpandIcon ? "10px" : "auto"}
              stroke={`${color}`}
              fill={`${color}`}
              opacity={disabled ? 0.45 : 1}
              cursor={disabled ? "default" : "pointer"}
              _hover={
                !disabled
                  ? {
                      ...otherStyles._hover,
                      fill: otherStyles._hover.color,
                      stroke: otherStyles._hover.color,
                      borderRadius: "5px"
                    }
                  : {}
              }
            />
          </IconContainer>
        </Root>
      ) : (
        <Root isOneTab={isOneTab}>
          <Flex
            direction="column"
            justify="center"
            backgroundColor={servicePanelBackgroundColor}
            borderTopLeftRadius="0.375rem"
            borderBottomLeftRadius="0.375rem"
          >
            {isExpandIcon && (
              <ExpandIcon
                backgroundColor={servicePanelBackgroundColor}
                fontSize="1.2rem"
                height="1.25rem"
              />
            )}
            <IconContainer
              onClick={
                isOneTab && canSeeChatTab ? handleOnClick : handleToggleSidebar
              }
              servicePanelBackgroundColor={servicePanelBackgroundColor}
              isOneTab={isOneTab}
            >
              <Icon
                src={BiChevronRightSquare}
                className={`sidebar-trigger ${sidebarOpen ? "open" : "close"}`}
                fontSize="32px"
                zIndex={101}
                color={`${color}`}
                opacity={disabled ? 0.45 : 1}
                marginTop="auto"
                cursor={disabled ? "default" : "pointer"}
                _hover={
                  !disabled
                    ? { color: `${otherStyles._hover.color} !important` }
                    : {}
                }
              />
            </IconContainer>
          </Flex>
        </Root>
      )}
    </>
  )
}

export const CollapseButton = React.memo(_CollapseButton)
